import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from 'emotion';
import { TextInput as SourceTextInput } from '@guardian/src-text-input';
import { space } from '@guardian/src-foundations';
const textInputStyles = css `
	margin-top: ${space[2]}px;
`;
export const TextInput = ({ formField, formData, setFormData }) => (_jsx(SourceTextInput, { className: textInputStyles, "data-testid": `form-field-${formField.id}`, type: formField.type, label: formField.label, supporting: formField.description, optional: !formField.required, value: formField.id in formData ? formData[formField.id] : '', onChange: (e) => setFormData({
        ...formData,
        [formField.id]: e.target.value,
    }) }, void 0));
